import ChangeLanguage from '../../translations/ChangeLanguage'

export default function HeaderClient() {
    return (
        <div className='cabecera d-flex justify-content-center align-items-center'>
            <img src="/images/logotipo-menu-reducido.png" alt="logotipo" className='logo'></img>
            <ChangeLanguage />
        </div>
    )
}